// @ts-nocheck
import { setRestrictedProductsToggleOn } from "@store/Framework/Store/Data/RestrictedProductsToggle/RestrictedProductsToggleUtilities";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ isRestrictedProductsActivated: boolean }>;

export const UpdateLocalStorageData: HandlerType = props => {
    setRestrictedProductsToggleOn(props.parameter.isRestrictedProductsActivated);
};

export const DispatchActivateRestrictedProducts: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/RestrictedProductsToggle/ActivateRestrictedProductsToggle",
        isRestrictedProductsToggleOn: props.parameter.isRestrictedProductsActivated,
    });
};

export const chain = [UpdateLocalStorageData, DispatchActivateRestrictedProducts];

const activateRestrictedProducts = createHandlerChainRunner(chain, "ActivateRestrictedProducts");
export default activateRestrictedProducts;
